import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import useDarkMode from '../../utils/theme';

const DeprtAttChart = ({ attData }) => {
  // console.log(attData)
  const shortenDeptName = (title) => {
    if (!title) return "Unknown";

    const lower = title.toLowerCase();

    if (lower.includes("web")) return "Web Dev";
    if (lower.includes("digital")) return "Marketing";
    if (lower.includes("it enable")) return "IT Enable";
    if (lower.includes("mobile")) return "Mobile Dev";
    if (lower.includes("desktop")) return "Desktop Dev";
    if (lower.includes("hr")) return "HR";
    if (lower.includes("admin")) return "Admin";

    return title; // fallback to original if no match
  };

  const attDataReport = attData.reduce((acc, curr) => {
    // const dept = curr.TITLE_1.slice(0,14) || "Unknown";
    const dept = shortenDeptName(curr.TITLE_1);
    const status = curr.ATTENDANCE_STATUS;

    if (!acc[dept]) {
      acc[dept] = { department: dept, present: 0, absent: 0, notStarted: 0 };
    }

    if (status === "Present" || status === "Late") {
      acc[dept].present += 1;
    } else if (status === "Absent") {
      acc[dept].absent += 1;
    } else if (status === "Time Not Started") {
      acc[dept].notStarted += 1;
    }

    return acc;
  }, {});

  const finalChartData = Object.values(attDataReport);
  const isDark = useDarkMode();

  // console.log("finalChartData", finalChartData)
  return (
    <div className="flex flex-col md:flex-row gap-2">
      <div className="bg-white dark:bg-gray-800 dark:text-white p-4  shadow rounded-lg w-full">
        <h2 className="text-xl lg:text-2xl font-bold text-center">Department Attendance</h2>
        {
          finalChartData?.length === 0 ? (
            // Empty State
            <div className="flex items-center justify-center h-[250px] text-gray-500 dark:text-gray-400 italic">
              No attendance data available
            </div>
          ) : (
            <ResponsiveContainer width="100%" height={250}>
              <BarChart
                data={finalChartData}
                margin={{ top: 40, right: 5, left: 0, bottom: 0 }}
                className='text-black dark:text-white'
              >
                <XAxis
                  dataKey="department"
                  stroke={isDark ? "#E5E7EB" : "#374151"}
                  fontSize={10}
                />

                <YAxis
                  stroke={isDark ? "#E5E7EB" : "#374151"}
                  fontSize={10}
                />
                <Tooltip />
                <Legend verticalAlign="top" height={36} />
                <Bar dataKey="present" fill="#6BE598" name="Present" />
                <Bar dataKey="absent" fill="#F44336" name="Absent" />
                <Bar dataKey="notStarted" fill="#9333EA" name="Time Not Started" />
              </BarChart>
            </ResponsiveContainer>
          )
        }
      </div>
    </div>
  );
};

export default DeprtAttChart;
